/**
 * Hook per leggere la UI della mappa (TS-124) del plugin abilitato: ricerca, disegno dei punti e
 * dettaglio, vedi @crm/contracts/MapContributor.
 *
 * Stesso filtering di useSidebarContributors: solo i plugin autorizzati dal backend
 * (user.plugins). Su una company la mappa è di un cliente solo: se più plugin abilitati la
 * dichiarano, vale il primo.
 */

import { useMemo } from 'react';
import type { MapContributor } from '@crm/contracts';
import { useEnabledPlugins } from './useEnabledPlugins';

export function useMapContributor(): MapContributor | null {
  const enabledPlugins = useEnabledPlugins();
  return useMemo(
    () => enabledPlugins.find((p) => p.mapContributor)?.mapContributor ?? null,
    [enabledPlugins],
  );
}
